import Utility from "../helpers/utility";
import LocalStorageFunc from "../helpers/localStorageFunc";

const ENV_CONFIG = JSON.parse(window._siteProps_.props.envConfig);
const amplitudeApiKey = ENV_CONFIG.AMPLITUDE_API_KEY;

let amplitudeConfigObj = {
  saveEvents: true,
  includeUtm: true,
  includeReferrer: true,
  saveParamsReferrerOncePerSession: false,
  unsetParamsReferrerOnNewSession: true,
};

var getAmpUserProperties = function () {
  let nghUtmSourceMedium = "";
  let queryParams = Utility.getQueryFromUrl();
  if (queryParams["utm_source"] && queryParams["utm_medium"]) {
    nghUtmSourceMedium =
      queryParams["utm_source"] + "-" + queryParams["utm_medium"];
  }

  const userAgent = window?.navigator?.userAgent || "";
  let deviceType = "desktop";
  if (/mobi|android/i.test(navigator?.userAgent?.toLowerCase() || "")) {
    deviceType = "mobile";
  } else if (/ipad|tablet/i.test(navigator?.userAgent?.toLowerCase() || "")) {
    deviceType = "tablet";
  }

  let landingPage = Utility.tryJsonParse(
    sessionStorage.LANDING_PAGE_FOR_NEXTGEN
  );
  if (landingPage == "/") {
    landingPage = "home";
  }
  try {
    landingPage =
      landingPage?.trim()?.replace(/^\/+/, "")?.replace(/\/+$/, "") || "home";
  } catch (e) {
    landingPage = "home";
  } finally {
    LocalStorageFunc.setSessionStorageKey(
      "LANDING_PAGE_FOR_NEXTGEN",
      landingPage
    );
  }

  let orderType = LocalStorageFunc.getDeliveryType();

  let networkType = navigator?.connection?.effectiveType || "N/A";
  let screenSize = `${window.screen.width}x${window.screen.height}`;
  let screenResolution = `${window.screen.width * window.devicePixelRatio}x${
    window.screen.height * window.devicePixelRatio
  }`;
  const orderTypeSubtitle = LocalStorageFunc.getOrderTypeSubtitle();
  let vwoNextGenPaymentAttribute =
    LocalStorageFunc.getSessionStorageKey("VWO_NEXT_GEN_PAYMENT_VARIANT") ||
    "NA";
  const storeId = LocalStorageFunc.storeId();

  return {
    utmSourceMedium: nghUtmSourceMedium,
    userAgent: userAgent,
    deviceType: deviceType,
    landingPage: landingPage,
    networkType: networkType,
    screenSize: screenSize,
    screenResolution: screenResolution,
    Order_type: orderType,
    ...orderTypeSubtitle,
    AB_EXPR_PAYMENT_V1: vwoNextGenPaymentAttribute,
    storeId,
  };
};

export default {
  amplitudeApiKey,
  amplitudeConfigObj,
  getAmpUserProperties,
};
